namespace('arctic.views.group');

compass.require('compass.arctic.NavBarWidget');

compass.require('compass.demographic.GroupInfoWidget');
compass.require('compass.demographic.PasswordWidget');
compass.require('compass.demographic.CreditCardWidget');
compass.require('compass.demographic.AddressWidget');

compass.require('compass.util.validate');

compass.require('compass.group.GroupContractWidget');


arctic.views.group.groupDemo = function (viewport,options) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('groupDemoView');
	/***
	 * Group contact info page view
	 *
	 * Has the fields for group name, group lead contact info
	 * the credit card, password, stay info
	 */
	var _viewport = viewport;
	var $j = jQuery;
	// Widgets are stored in an object, keeps them together and saves namespace
	var widgets = {};

	var _settings = options;
    var _data;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
			_checkWholeForm();
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var _str2date = function (src) {
		src = src.split("/");
		return new Date(parseInt(src[2], 10), parseInt(src[0], 10),
				parseInt(src[1], 10), 0, 0, 0, 0);
	};


	var _jsonData;

	var me = this;
	var _meeting;
	var _details;
	var _hotel;

	var	URL = {
			submit : "/actGroupDemo",
			request : "/getGroupDemo"
		};


	var render = function (d) {
		_viewport.append(d.div({ className : 'groupInfo' },
			d.div({ className : 'reservationRecap' }),
			d.div({ className : 'separator'}),
			d.div({ className : "forms" },
				d.div({ className : 'groupInfoHeader'},
					d.div({ className : 'groupInfoTitle'}, 'Group Reservation')
				),
				d.div({className : 'groupInfoInstruction'},
					"Start by entering the group's main contact info and you'll have the option to enter guest details and other preferences for each room in just a moment."
				),
				d.div({ className : 'groupInfoMain' }),
				d.div({ className : 'passwordInfo' }),
				d.div({ className : 'addressInfo' }),
				d.div({ className : 'paymentHeader' },
					d.div({ className : 'paymentTitle'}, 'Group Payment Guarantee')
				),
				d.div({ className : 'creditCardTitle demographicTitle' }, "We need a credit card to hold your rooms. Don't worry, we won't charge it today. You'll have the option to keep your rooms guaranteed under this card or have each guest enter their own credit card. Review the hotel policies for additional information."),
				d.div({ className : 'creditCard' }),
				d.separator(),
				d.div({className : 'policiesAgreeDiv'},
					d.input({className : 'policiesCheckbox',
						type: 'checkbox',
						value:'true'}),
					d.div({className :'policiesTextDiv'}, 'I agree to the' ),
					d.a({ className:'policiesLink'}, 'hotel policies'),
					d.div({ className : 'clear'})
				),

				d.div({ className : 'saveButton button',
					type : 'submit'}, 'Save')
			),
			d.div({ className : 'stayRecap' })
		));
	};

	var _showPoliciesPopup = function(data) {
		jQuery.ajax({
			data: {
				blocked_room_id: _jsonData.blockRoomId
			},
			dataType:'json',
			traditional: true,
			url:'/policies',
			success : function(data) {
				var d = jQuery.dom;
				var policiesDiv = d.div({className:'policiesContainer'});

				_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv,
					{
						WUID : 'policiesWidget_individualPersonalInfo',
						policies: data
					});

				_policiesDialog = d.dialog({
					classes: 'personalInfo policiesDialog',
					contents: policiesDiv,
					centerOnView: true
				});
			}
		});
	};

	var _invalid_fields = [];
	var sendInfo = function (event) {
		var d = jQuery.dom;
		var button = _viewport.find('.saveButton');
		var data = {};
		data.payment = widgets.creditCard.grabValues();

		if(button.hasClass('disabled')) {
			return;
		}
		button.addClass('disabled');

		data.policiesCheckbox = $j('policiesCheckbox').prop('checked');
		if(data.policiesCheckbox === false){
			_policiesAgreeDialog = d.alert('Please agree to the hotel policies before continuing');

		}

		// let's detach any hints that are attached to currently invalid fields
		var vh = compass.util.validationHelper(_validator);
		vh.detachHints();
		
 		var errorsExist = vh.attachHints();
 		if(errorsExist){
 			return;
 		}

		data.contact = widgets.groupInfoMain.grabValues();
		if (widgets.passwordInfo) {
			data.password = widgets.passwordInfo.grabValues();
		}

		compass.loading.start(button.empty(), { color : '#FFFFFF' });
		function finishLoading() {
			compass.loading.stop();
			button.empty().append('Save');
		}

		$j.ajax({
			url: URL.submit,
			data : JSON.stringify(data),
			type : 'POST',
			contentType : 'application/json',
			processData: false,
			error: function (data) {
				button.prop("disabled", false);
			},
			success: function (data) {
				_viewport.trigger(CompassEvents.Navigate, 'frontDesk');
				finishLoading();
			}
		});
	};

	var makeWidget = function (params) {
		/***
		 * This is a space saving function, generates the widget passed in as /params.widget/
		 * and saves it under the alias in /params.name/ in the /widgets/ object and renders it
		 * in the DOM object with the idea also from /params.name/ (could be changed later).
		 */
		var name = params.name;
		var widget = params.widget;
		var settings = typeof params.settings === 'object' ? params.settings : {};

		settings.WUID = 'groupView_' + name;

		widgets[name] = new widget(
				viewport.find("." + name), settings);
	};

	var generateHeader = function () {
		var header = $j(".showHeader");

		header.children("h1").text(_meeting.name);
		header.children("h3").text(_meeting.dates + " | "
				+ _meeting.venue + " | " + _meeting.location);
	};

	var setup = function (data) {
		var d = jQuery.dom;
		/***
		 * Runs through the widgets that need to be setup and generates them, storing them
		 * in the /widgets/ object
		 */
		_jsonData = data;
		meeting = data.meeting;
		_hotel = data.hotel;
		var recapArray = data.reservations;
		makeWidget({ name: "groupInfoMain", widget: compass.demographic.GroupInfoWidget,
			settings: {
				label: "Company/Group Name",
				validator: _validator,
				prefill: data.groupInfo
			}});
		if (!data.groupInfo) {
			makeWidget({ name: "passwordInfo", widget: compass.demographic.PasswordWidget,
					settings: {
						validator: _validator
					}
				});
		}

		
		
    		makeWidget({ name: "creditCard", widget: compass.demographic.CreditCardWidget,
    				settings: {
    					addressWidget : {countries : _settings.countriesAndStates.countries, states : _settings.countriesAndStates.states, countries_with_states : _settings.countriesAndStates.countries_with_states},
    					validator: _validator,
    					creditCardTypes : data.paymentOptions.pay_methods,
    					displayCVC: data.paymentOptions.store_cvc,
    					currentPayment : (data.groupInfo && data.groupInfo.payments && data.groupInfo.payments.length > 0 )  ? data.groupInfo.payments[0] : false,
    					storedCards: (data.groupInfo && data.groupInfo.payments && data.groupInfo.payments.length > 0) ? data.groupInfo.payments  : false,
    					minExpiration: _str2date(_settings.meetingInfo.ends),
    					maskCCNumber : _.contains(data.extraRequiredFields, 'maskCreditCard')
    				}
    			 });
    
            var creditCardWidget = widgets.creditCard;
            
            if ( data.groupInfo && data.groupInfo.address ){
                var addressObj = data.groupInfo.address;
                addressObj.postalCode = addressObj.postal_code;
                     var aw = creditCardWidget.getAddressWidgetJSObject().setAddress(addressObj);
            }

        _viewport.find(".policiesLink").activate(function(){
            _showPoliciesPopup(data);
        });

        _viewport.bind("GroupContractWidget.policiesClicked", function(){
            _showPoliciesPopup(data);
        });



		_validator.addFields(_viewport.find('.policiesCheckbox'), function(policiesCheckbox){
			if(policiesCheckbox.prop('checked'))
			{
				return _validator.VALID;
			}
			else
			{
				return _validator.INVALID;
			}
		});
		_viewport.find(".saveButton").activate(sendInfo);
		
		_viewport.find('.policiesCheckbox').change(function() {
			if ($(this).is(':checked')) {
				$('.alertCloseButton').activate();
			}
		});	
	};

	var _checkWholeForm = function() {
		_validation_res = _validator.validate();

		if (_validation_res.length === 0) {
			var button = _viewport.find(".saveButton");
			button.removeClass('disabled');
		}
	};

	this.run = function (renderComplete) {
		compass.loading.start();

		$j.ajax({
			url: URL.request,
			success: function (data) {
				_settings.countriesAndStates = data.countriesAndStates;
				_data = data;

				render(jQuery.dom);
				setup(data);
				compass.loading.stop();
				// stops measuring the time it takes the view to load
				compass.stopLoad('groupDemoView');
				renderComplete();
			}
		});
	};

};
